import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-canone-rai',
  templateUrl: './canone-rai.component.html',
  styleUrls: ['./canone-rai.component.scss']
})
export class CanoneRaiComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/canone-rai/Canone-rai.component.ts